var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Tooltip } from '@payscale/design';
var PeopleInChat = (function (_super) {
    __extends(PeopleInChat, _super);
    function PeopleInChat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PeopleInChat.prototype, "componentDidMount", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var peopleInChatStore = this.props.store.messageStore.peopleInChatStore;
            if (peopleInChatStore.shouldHidePeopleInChat) {
                return;
            }
            var _a = this.props, masterAccountId = _a.masterAccountId, userId = _a.userId, employeeSourceId = _a.employeeSourceId;
            peopleInChatStore.getOtherPeopleNames(masterAccountId, userId, employeeSourceId);
        }
    });
    Object.defineProperty(PeopleInChat.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var peopleInChatStore = this.props.store.messageStore.peopleInChatStore;
            if (peopleInChatStore.shouldHidePeopleInChat) {
                return null;
            }
            if (peopleInChatStore.isInitialLoading) {
                return (React.createElement("div", { className: " people-chat pxl-text-c11-2 pxl-text-center" },
                    React.createElement("span", null,
                        React.createElement("i", { className: "icon-animate-spin icon-spin" }))));
            }
            return (React.createElement("div", { className: "people-chat pxl-text-center pxl-text-sm pxl-text-c11-6" }, this.renderPeopleInChatText()));
        }
    });
    Object.defineProperty(PeopleInChat.prototype, "renderPeopleInChatText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (React.createElement("span", null,
                "You and\u00A0",
                this.renderOtherPeopleText(),
                "\u00A0are in this conversation"));
        }
    });
    Object.defineProperty(PeopleInChat.prototype, "renderOtherPeopleText", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var peopleInChatStore = this.props.store.messageStore.peopleInChatStore;
            if (peopleInChatStore.otherPeopleNames.length === 0) {
                return (React.createElement("span", null, peopleInChatStore.otherPeopleText));
            }
            return (React.createElement(Tooltip, { className: "pxl-text-turquoise", hoverText: peopleInChatStore.otherPeopleNamesText, tooltipText: peopleInChatStore.otherPeopleText, display: "underline", position: "bottom", id: "peopleInChatTooltip" }));
        }
    });
    return PeopleInChat;
}(React.Component));
export { PeopleInChat };
export default inject('store')(observer(PeopleInChat));
